export default {
  methods: {
    /* href */
    formatHref (url, options = {}, areaId) {
      var link = ''
      var param = '?'
      const sid = areaId || this.sid || this.global.area_id
      const year = (this.global.config[sid] && this.global.config[sid].year) || this.global.year
      const address = (this.global.config[sid] && (this.global.config[sid].address || (year + (this.global.config[sid].jieshu || sid)))) || this.global.address
      for (let k of Object.keys(options)) {
        param += `${k}=${options[k]}&`
      }
      param = param.slice(0, -1)
      if (year >= this.global.limitYear) {
        link = `/${address}${url}${param}`
      } else {
        if (options.cid) {
          param += `${param.includes('?') ? '&' : '?'}id=${options.cid}`
        }
        link = `${url}${param}`
      }
      // console.log('formatHref ', link)
      return link
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/session.js